import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AuthCookieService,
  AuthService,
  IdleService,
  SignalRService,
} from '@vinnova/auth';
import { TranslateService } from '@vinnova/translation';
import { AnalyticsInitializerService } from '@vinnova/utilities';
import { environment } from '../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  isProduction: boolean;

  constructor(
    private authCookieService: AuthCookieService,
    private authService: AuthService,
    private translateService: TranslateService,
    private idleService: IdleService,
    private signalRService: SignalRService,
    private analyticsInit: AnalyticsInitializerService,
  ) {}

  async ngOnInit() {
    this.isProduction = environment.production;
    this.authService
      .onLoggedIn([this.idleService.initIdle()])
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authService
      .onLoggedIn()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.signalRService.init(
          [
            `https://${environment.b2cMsalConfig.tenant}.onmicrosoft.com/${environment.b2cMsalConfig.clientId.etjansterCommonApiClientId}/all`,
          ],
          environment.b2cMsalConfig.authority,
        );
      });

    this.translateService
      .setActiveLang()
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authCookieService
      .tokenSuccess()
      .pipe(untilDestroyed(this))
      .subscribe();

    this.analyticsInit.load(environment.ga4MeasurementId);
  }
}
